import React, { useMemo } from "react";
import SlideButtonGroup from "./SlideButtonGroup";
import WrewardsButton from "components/wrewards-ui-kit/Button";
import Image from "next/image";
import { TheLeaderboardSourceKeys } from "interfaces";
import { CSSProperties } from "styled-components";
import { PublicLeaderboardProvider } from "types/leaderboard";

const defaultLeaderboardOptions = [
  {
    key: TheLeaderboardSourceKeys.gamdom,
    src: "/images/AllBonuses/provider-logos/gamdom-32.png",
    width: 105,
    height: 52,
  },
  {
    key: TheLeaderboardSourceKeys.packdraw,
    src: "/images/AllBonuses/provider-logos/packdraw-32.png",
    width: 131,
    height: 60,
  },
  {
    key: TheLeaderboardSourceKeys.clash,
    src: "/images/AllBonuses/provider-logos/clash-32.png",
    width: 120,
    height: 36,
    style: {
      position: "relative",
      top: 2,
    },
  },
  {
    key: TheLeaderboardSourceKeys.cases,
    src: "/images/AllBonuses/provider-logos/cases-32.png",
    width: 100,
    height: 40,
  },
  {
    key: TheLeaderboardSourceKeys.rain,
    src: "/images/AllBonuses/provider-logos/rain.png",
    width: 100,
    height: 30,
    style: {
      position: "relative",
      top: -3,
    },
  },
  {
    key: TheLeaderboardSourceKeys.luxdrop,
    src: "/images/AllBonuses/provider-logos/luxdrop.png",
    width: 121,
    height: 52,
  },
  {
    key: TheLeaderboardSourceKeys.hypedrop,
    src: "/images/AllBonuses/provider-logos/hypedrop.svg",
    width: 131,
    height: 60,
  },
  {
    key: TheLeaderboardSourceKeys.lootbox,
    src: "/images/AllBonuses/provider-logos/lootbox-logo.svg",
    width: 121,
    height: 52,
  },
  {
    key: TheLeaderboardSourceKeys.wrewards,
    src: "/images/AllBonuses/provider-logos/wrewards-32.png",
    width: 121,
    height: 52,
  },
  {
    key: TheLeaderboardSourceKeys.datdrop,
    src: "/images/AllBonuses/provider-logos/datdrop.png",
    width: 121,
    height: 60,
    style: {
      width: 140,
      height: 40,
    },
  },
];

type Props = {
  value: string;
  onChange: (v: string) => void;
  maxWidth?: number;
  leaderboardProviders: PublicLeaderboardProvider[];
};

function LeaderboardProviderSwitcher({ value, onChange, maxWidth, leaderboardProviders }: Props) {
  const leaderboardOptions = useMemo(() => {
    return defaultLeaderboardOptions.filter((lbProvider) =>
      leaderboardProviders.some((lbOption) => lbOption.providerName === lbProvider.key)
    );
  }, [leaderboardProviders]);

  return (
    <SlideButtonGroup maxWidth={maxWidth}>
      {leaderboardOptions.map(({ key, src, style }) => {
        return (
          <WrewardsButton
            style={{ minWidth: 220 }}
            className={key === value ? "active" : ""}
            variant="ghost-neon"
            key={key}
            onClick={() => onChange(key)}
          >
            <div className="img" style={style as CSSProperties}>
              <Image fill src={src} alt="" style={{ objectFit: "contain" }} />
            </div>
          </WrewardsButton>
        );
      })}
    </SlideButtonGroup>
  );
}

export default LeaderboardProviderSwitcher;
